export default {
  path: 'shipin',
  component: () => import('@/components/shipin'),
  children: [
    {
      path: '',
      name: 'Add',
      component: () => import('@/components/shipin/add'),
    },
    {
      path: 'success',
      name: 'ShipinSuccess',
      component: () => import('@/components/shipin/success'),
    },
    {
      path: 'csuccess',
      name: 'ShipinCsuccess',
      component: () => import('@/components/shipin/csuccess'),
    },
    {
      path: 'sfail',
      name: 'ShipinSfail',
      component: () => import('@/components/shipin/sfail'),
    },
    {
      path: 'cfail',
      name: 'ShipinCfail',
      component: () => import('@/components/shipin/cfail'),
    },
    {
      path: 'chose',
      name: 'ShipinChose',
      component: () => import('@/components/shipin/chose'),
    },
    {
      path: 'confimeBind',
      name: 'ConfimeBind',
      component: () => import('@/components/shipin/confimeBind'),
    },
    
  ]
}



// WEBPACK FOOTER //
// ./src/router/shipin.js